import React, { useState } from "react";
import { Button, Modal, ModalBody } from "react-bootstrap";
import './index.css';
import { Container, Row } from 'react-bootstrap';
// import useFormModal from "../Utils/useFormModal";
import htmlParser from "html-react-parser"; // Import the parser

const scrollToForm = () => {
    const formSection = document.getElementById('ContactMeForm');
    if (formSection) {
      const elementPosition = formSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset;
      const offsetValue = -80;
      window.scrollTo({
        top: offsetPosition + offsetValue,
        behavior: 'smooth'
      });
    }
   
  };

const HowItWorks = ({ data }) => {


   
     // Add safe destructuring with default values
     const { 
        title = "", 
        description = "", 
        applynow = "" 
    } = data?.howItWorks || {};

    return (
        <div className="howdivtesd">
        <section id="howitworks">
            <Container>
                <Row>
                    <div className="how-it-works-section">
                        <h1>{htmlParser(title)}</h1>
                        <p>{htmlParser(description)}</p>
                        <button className="apply-now-mm" onClick={scrollToForm}>{applynow}</button>
                    </div>

                </Row>
            </Container>
          
        </section>
        </div>
    );
};

export default HowItWorks;
